export default {
  error_param: 'Parameter error',
  loading: 'Loading...',
  version: 'Version',
  size: 'Size',
  query_failed: 'Query failed',
  for_ios: 'For iOS',
  for_android: 'For Android',
  install: 'Install'
}
